export default __webpack_public_path__ + "static/media/telecom-image.0b827193.svg";